export default "__VITE_ASSET__B0JwOp8A__"